import { RugbyUnionIncidentId } from '@collector/sportsapi-client-legacy'

export const customIncidentNames = new Map([
  [RugbyUnionIncidentId.Cards, 'Cards'],
])
